import { ImgPreviewItemStyle } from './style'
import { RiDeleteBin3Line, RiMusic2Fill } from 'react-icons/ri'
import { UploadFile } from 'antd/es/upload/interface';

function ImgPreviewItem({item,onDelete}:{item:UploadFile,onDelete:(item:UploadFile)=>void}) {
  const file = item.originFileObj
  if(!file) return <></>
  console.log(file)
  const name = file.name.split(".").shift() + ""
  return (
    <ImgPreviewItemStyle>
        <div className='image'>
            <div className='actions'>
                <div className='item' onClick={()=>onDelete(item)}> <RiDeleteBin3Line></RiDeleteBin3Line></div>
            </div>
            <RiMusic2Fill size={30} />
        </div>
        <div className="name" title={name}>{name}</div>
    </ImgPreviewItemStyle>
  )
}

export default ImgPreviewItem